// Frontend-only display mapping for verdict / gate labels.
//
// IMPORTANT: Backend enum values (GO / CONDITIONAL / NO-GO / CAUTION /
// EARN_CAUTION / PASS / FAIL) are NEVER changed. Only the *text rendered to the
// user* is neutralised here, so the regulatory language stays observational
// without touching any engine logic, comparisons, or colour maps (which remain
// keyed on the original enum values).

export const VERDICT_DISPLAY = {
  // Phase 4 compliance — descriptive parameter language, never directive.
  // The backend enum (GO / CONDITIONAL / NO-GO …) is unchanged; only the
  // rendered text is neutralised so colour maps and downstream logic keyed
  // on the enum keep working.
  GO: "Within Historical Band",
  CONDITIONAL: "Indicators Partially Within Band",
  "NO-GO": "Parameters Outside Standard Band",
  NO_GO: "Parameters Outside Standard Band",
  CAUTION: "Mixed Indicators",
  EARN_CAUTION: "Earnings Window Active",
  WEAK: "Limited Data",
  HOLD: "Mixed Indicators",
  PASS: "Within Band",
  FAIL: "Outside Band",
  FAVOURABLE: "Within Historical Band",
  UNFAVOURABLE: "Parameters Outside Standard Band",
};

export function verdictDisplay(v) {
  if (v == null) return "";
  return VERDICT_DISPLAY[v] ?? v;
}

export const READINESS_CHECK_LABEL = "Readiness Check";
export const MODEL_SCORE_LABEL = "Model Score";

// ── No-visibility contract (user policy, iter 102) ──
// When a trade's DTE runs past the regime's P75 expected life, the execution
// model has NO visibility that far out. The verdict is rendered as a neutral
// "beyond visibility" state (user's own judgment) with P(NT) surfaced for
// reference — never as a hard Conditions-Not-Met judgment.
export const NO_VISIBILITY_LABEL = "Beyond Model Visibility";
export const NO_VISIBILITY_COLOR = "#3B82F6";

export function beyondVisibility(dte, sojournP75) {
  return dte != null && sojournP75 != null && Number(sojournP75) > 0 && Number(dte) > Number(sojournP75);
}

export function noVisibilityNote(dte, sojournP75, pnt) {
  const base = `The regime's expected life (P75 ≈ ${Math.round(sojournP75)}d) is shorter than this ${Math.round(dte)}d trade — the model cannot assess conditions that far out. You're on your own judgment here.`;
  return pnt != null ? `${base} For reference: P(NT) ${pnt}%.` : base;
}

// Permanent analytics disclaimer rendered below the Readiness Check on the
// StrategyCard (and reusable anywhere a neutral statement is required).
export const ANALYTICS_DISCLAIMER =
  "Statistical model output for research and educational purposes only. Not investment advice or a recommendation to buy or sell any security. Modeled probabilities and historical results do not guarantee future outcomes.";
